module.exports = __webpack_public_path__ + "static/media/1022728.70ea0dde.jpg";